import React from 'react';
const areas = [{
  icon: '🗣️',
  title: 'Lenguaje',
  desc: 'Cuadernillos y fichas por nivel de desarrollo'
}, {
  icon: '🧠',
  title: 'Atención y concentración',
  desc: 'Actividades progresivas, de menor a mayor dificultad'
}, {
  icon: '✋',
  title: 'Motricidad',
  desc: 'Ejercicios finos y gruesos listos para imprimir'
}, {
  icon: '💛',
  title: 'Emociones',
  desc: 'Recursos para identificar, nombrar y regular'
}, {
  icon: '🧩',
  title: 'TEA • TDAH • Dislexia',
  desc: 'Material con más estructura, más visual, menos frustración'
}, {
  icon: '📋',
  title: 'Rutinas visuales',
  desc: 'Tableros y pictogramas para ordenar el día'
}, {
  icon: '📝',
  title: 'Planillas editables',
  desc: '+60 planillas para registrar avances y planificar'
}, {
  icon: '📚',
  title: 'Lectoescritura y matemática inicial',
  desc: 'Base para chicos de 4 a 7 años'
}];
export function ProductShowcase() {
  return <section className="pt-10 md:pt-20 pb-10 md:pb-20 px-4 bg-brand-light" data-id="element-244">
      <div className="max-w-5xl mx-auto text-center" data-id="element-245">
        <h2 className="text-3xl md:text-5xl font-black text-brand-dark mb-6" data-id="element-246">
          Por eso existe el MEGA PACK DESARROLLO INFANTIL 360
        </h2>

        <p className="text-xl md:text-2xl font-bold text-brand-blue mb-4" data-id="element-247">
          Una biblioteca imprimible lista para usar, pensada para que dejes de
          buscar y empieces a aplicar desde hoy.
        </p>

        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-12" data-id="element-248">
          Todo lo que necesitás para trabajar con chicos de 2 a 10 años, en un
          solo lugar, sin pantalla.
        </p>

        <h3 className="text-2xl md:text-3xl font-black text-brand-dark mb-8" data-id="element-249">
          📦 ¿Qué recibís exactamente?
        </h3>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-12 text-left" data-id="element-250">
          {areas.map((area, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 flex items-start gap-4" data-id="element-251">
              <div className="text-3xl flex-shrink-0" data-id="element-252">{area.icon}</div>
              <div data-id="element-253">
                <h4 className="text-lg font-bold text-brand-dark mb-1" data-id="element-254">
                  {area.title}
                </h4>
                <p className="text-gray-600" data-id="element-255">{area.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="max-w-2xl mx-auto mb-8 rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-[#2a2a3a] via-[#3a3a4a] to-[#8b5e34]" data-id="element-256">
          <img src="https://cdn.magicpatterns.com/uploads/dhbXXAf4wHFATGLH9eN3dQ/PROMPT_ES_Disea_una_portada_ti_Nano_Banana_2_39728.jpg" alt="Mega Pack Desarrollo Infantil 360" className="w-full" data-id="element-257" />
        </div>

        <div className="inline-block bg-brand-dark text-white font-bold text-lg md:text-xl px-8 py-4 rounded-xl shadow-lg" data-id="element-258">
          Total: +1000 actividades organizadas por edad (2 a 10 años) y por
          objetivo.
        </div>
      </div>
    </section>;
}